import { get } from './request'

export let listPaymentMethods = (success, failure) => get(
  `api/payment-method/list`, success, failure
)
